import { Alert, AlertTitle, Box, bounce } from 'ui';
import { ErrorOutlined, SystemUpdate } from 'ui/icons';

import { relativeZIndex } from '../../config';
import type { AlertMessageState } from '../../hooks/useAlertMessagePriority/useAlertMessagePriority';
import { TiltDirection } from '../../types';

export const InfoText = ({ alertState }: { alertState: AlertMessageState }) => {
  const { showAlert, message, severity, tiltDirection, title } = alertState;

  return showAlert ? (
    <Box
      sx={() => ({
        left: '50%',
        position: 'absolute',
        top: '5%',
        transform: 'translateX(-50%)',
        width: '80%',
      })}
    >
      <Alert
        severity={severity}
        icon={
          tiltDirection ? (
            <SystemUpdate
              sx={{
                animation: bounce,
                rotate: tiltDirection === TiltDirection.Down ? '0deg' : '180deg',
              }}
            />
          ) : (
            <ErrorOutlined />
          )
        }
        sx={({ zIndex }) => ({
          zIndex: zIndex.modal + relativeZIndex.infoText,
        })}
      >
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {message}
      </Alert>
    </Box>
  ) : null;
};
